import React from 'react';

function Home() {
  return (
    <div className="slds-grid slds-gutters">
      <div className="slds-col slds-size_1-of-1">
        <div className="slds-card">
          <div className="slds-card__body slds-card__body_inner">
            <h1 className="slds-text-heading_large slds-p-bottom_medium">
              Welcome to Peak Autism Center
            </h1>
            <p className="slds-text-body_regular slds-p-bottom_medium">
              Peak Autism Center offers high-quality, effective therapy through the use of Applied Behavior Analysis (ABA). 
              Our empirically based treatment focuses on learning and behavior, using a variety of techniques and strategies 
              to develop customized treatment plans for every individual's specific needs.
            </p>
            <div className="slds-grid slds-gutters slds-p-top_medium">
              <div className="slds-col slds-size_1-of-1">
                <div className="slds-card">
                  <div className="slds-card__body slds-card__body_inner">
                    <h2 className="slds-text-heading_medium slds-p-bottom_small">Our Mission</h2>
                    <p className="slds-text-body_regular">
                      We are dedicated to providing the highest quality ABA therapy services to help individuals with autism 
                      reach their full potential and lead independent, fulfilling lives.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home; 